export interface Result {
  fileName?: string;
  header: Header;
  nuclideData: Nuclide[];
}

export interface Header {
  sampleName: string;
  measureDate: Date;
  activeTime: number;
  deadTime: number;
  size: number;
  sizeUnit: string;
}

export const DEFAULT_NAME = '';
export const DEFAULT_DATE = new Date(0);
export const DEFAULT_ACTIVE_TIME = 0;
export const DEFAULT_DEAD_TIME = 0;
export const DEFAULT_SIZE = 0;
export const DEFAULT_SIZE_UNIT = 'Unit';

export interface Nuclide {
  nuclideName: string;
  nuclideDL: number;
  bestActivity: number;
  estimationUncertainty: number;
}

export const DEFAULT_NUCLIDE_DL = -1;
export const DEFAULT_BEST_ACTIVITY = -1;
export const DEFAULT_ESTIMATION_UNCERTAINTY = -1;
